export default {
  roadmap: {
    roadmapKanbanColumnNoItemsStub: {
      todo: {
        title: 'You can create own tasks or assign it to other',
        description: 'Don’t tell people your dreams - Show them. Set the goal and go for it',
      },
      inProgress: {
        title: 'You are halfway to your goal. Everything is possible',
        description: 'Do it now. Sometimes later becomes never',
      },
      done: {
        title: 'You’ve done an amazing job. Keep going!',
        description: 'Once you start something don’t stop until you complete it',
      },
    },
  },
};
